import React from 'react';
import { arrayOf, bool, number, shape, string } from 'prop-types';

import {
  SIGNED_IN_HOME_PATH,
  PRICING_PATH,
  BUSINESS_PATH,
  getSignUpRedirectPath,
  getSignInRedirectPath,
} from 'routes';

import withCurrentPath from 'hoc/withCurrentPath';

import { ChevronDownIcon } from '@datacamp/waffles-icons';

import Button from 'components/buttons/Button';
import LearnDropdown from 'components/Navbar/LearnDropdown';

import { A, Links, Trigger } from 'components/Navbar/DesktopStyles';

const pageview = () =>
  typeof window !== 'undefined' &&
  window.snowplow('trackStructEvent', 'dropdown', 'display', 'learn-dropdown');

class Desktop extends React.Component {
  componentDidMount() {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      document
        .querySelector('.js-learn-nav-link')
        .addEventListener('mouseenter', pageview);
    }
  }

  componentWillUnmount() {
    document
      .querySelector('.js-learn-nav-link')
      .removeEventListener('mouseenter', pageview);
  }

  render() {
    const {
      colors,
      navigationInfo,
      createAccount,
      currentPath,
      isSignedIn,
    } = this.props;

    return (
      <Links>
        <Trigger className="trigger js-learn-nav-link" href="#" colors={colors}>
          Learn
          <ChevronDownIcon className="icon" />
          <LearnDropdown navigationInfo={navigationInfo} />
        </Trigger>
        <A
          className="ds-snowplow-li-main-menu-pricing"
          href={PRICING_PATH}
          colors={colors}
        >
          Pricing
        </A>
        <A
          className="ds-snowplow-li-main-menu-for-business"
          href={BUSINESS_PATH}
          colors={colors}
        >
          For Business
        </A>
        {!isSignedIn && (
          <Button
            as="a"
            borderColor={waffles => waffles.theme.colors.primary}
            hoverBorderColor={waffles => waffles.theme.colors.secondary}
            textColor={
              colors && colors === 'darkOnLight'
                ? waffles => waffles.theme.colors.grey
                : waffles => waffles.theme.colors.white
            }
            href={getSignInRedirectPath(currentPath)}
          >
            Sign In
          </Button>
        )}
        {!isSignedIn && createAccount && (
          <Button
            as="a"
            bg={waffles => waffles.theme.colors.white}
            borderColor={waffles => waffles.theme.colors.white}
            boxShadow={waffles => waffles.theme.shadows.sm}
            className="create"
            href={getSignUpRedirectPath(currentPath)}
            textColor={waffles => waffles.theme.colors.primary}
          >
            Create Free Account
          </Button>
        )}
        {isSignedIn && (
          <Button
            as="a"
            bg={waffles => waffles.theme.colors.white}
            borderColor={waffles => waffles.theme.colors.white}
            boxShadow={waffles => waffles.theme.shadows.sm}
            className="create"
            href={SIGNED_IN_HOME_PATH}
            textColor={waffles => waffles.theme.colors.primary}
          >
            My Dashboard
          </Button>
        )}
      </Links>
    );
  }
}

Desktop.defaultProps = {
  colors: null,
};

Desktop.propTypes = {
  createAccount: bool.isRequired,
  navigationInfo: shape({
    course_count: number,
    career_track_count: number,
    skills_track_count: number,
    instructor_count: number,
    featured_courses: arrayOf(
      shape({
        title: string,
        slug: string,
      })
    ),
    featured_tracks: arrayOf(
      shape({
        title_with_subtitle: string,
        category: string,
        slug: string,
      })
    ),
    featured_instructors: arrayOf(
      shape({
        full_name: string,
        slug: string,
      })
    ),
  }).isRequired,
  currentPath: string.isRequired,
  isSignedIn: bool,
  colors: string,
};

Desktop.defaultProps = {
  isSignedIn: undefined,
};

export default withCurrentPath(Desktop);
